import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import {
  ICacheCatalogue,
  ICacheEntry,
  IClearCacheRequestPayload,
  IClearCacheResult,
} from 'dashboard/types';

/**
 * The catalogue of clearable caches. Carries no labels by design — those are
 * user-facing text and live in the translations, keyed by the cache key.
 */
export const getCaches = async (signal?: AbortSignal): Promise<ICacheCatalogue> => {
  const { data } = await partfinitiClient.get('/admin/cache/caches', signal);

  return {
    caches: mapRecordsFromServer<ICacheEntry>(data?.data?.caches ?? []).records,
    environment: data?.data?.environment ?? '',
  };
};

export const clearCache = async (
  requestPayload: IClearCacheRequestPayload
): Promise<IClearCacheResult> => {
  const response = await partfinitiClient.postForm('/admin/cache/clear', requestPayload);

  return response?.data as IClearCacheResult;
};
